import React from "react";
import NotFoundPage from "../common/NotFoundPage";

const NoNotificationFound = (props: { message?: string; label?: string }) => {
  return (
    <NotFoundPage
      title="All caught up!"
      monitorText="No User"
      description={
        props.message || `You don't have any blocked ${props.label || "items"}.`
      }
    />
  );
};

export default NoNotificationFound;
